<template>

<footer id="footer" class="footer dark-background">
    <div class="container">
      <h3 class="sitename">ANAGEM</h3>
      <p>Votre agence de gestion des marchés, plus près de vous.</p>
      <div class="social-links d-flex justify-content-center">
        <a href=""><i class="bi bi-twitter-x"></i></a>
        <a href=""><i class="bi bi-facebook"></i></a>
        <a href=""><i class="bi bi-instagram"></i></a>
        <a href=""><i class="bi bi-skype"></i></a>
        <a href=""><i class="bi bi-linkedin"></i></a>
      </div>
      <div class="container">
        <div class="copyright">
          <span>Copyright</span> <strong class="px-1 sitename">Anagem</strong> <span>Tous droits réservés</span>
        </div>
        <div class="credits">
          Conçue par <a href="https://romastechnologie.com/">ROMAS TECHNOLOGIE</a>
        </div>
      </div>
    </div>
  </footer>
  <!-- Scroll Top -->
  <a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
</template>
<script lang="ts">
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "FooterV",
  components: {},
  setup() {
    //
  },
});
</script>
<style scoped>
h1, h2, h3, h4, h5, h6 {
    color: #fff;
}
</style>